import { RandomGenerator } from "../../test-utils";
import { Channel } from "../tickets";
import { InteractionStatus } from "./interaction-status.enum";
import { InteractionTransferInfoBuilder } from "./interaction-transfer-info.builder";
import { ParticipantInfoBuilder } from "./participant-info.builder";
var TicketInteractionBuilder = /** @class */ (function () {
    function TicketInteractionBuilder() {
        var _a;
        this.ticketInteraction = {
            id: RandomGenerator.id(),
            ticketId: RandomGenerator.id(),
            channel: Channel.CHAT,
            status: InteractionStatus.COMPLETED,
            lastAssignedGroupId: RandomGenerator.id(),
            lastAssignedUserId: RandomGenerator.id(),
            participants: {
                participantsInfo: (_a = {},
                    _a[RandomGenerator.id()] = new ParticipantInfoBuilder().build(),
                    _a),
            },
            transferInfo: new InteractionTransferInfoBuilder().build(),
            startedByUser: false,
            endedByUser: false,
            creationDate: Date.now(),
            firstAssignmentDate: Date.now(),
            firstResponseDate: Date.now(),
            firstHumanResponseDate: Date.now(),
            waitingStartDate: Date.now(),
            waitingEndDate: Date.now(),
            activeStartDate: Date.now(),
            activeEndDate: Date.now(),
            endDate: Date.now(),
            lastUpdateDate: Date.now(),
        };
    }
    TicketInteractionBuilder.prototype.withId = function (id) {
        this.ticketInteraction.id = id;
        return this;
    };
    TicketInteractionBuilder.prototype.withTicketId = function (ticketId) {
        this.ticketInteraction.ticketId = ticketId;
        return this;
    };
    TicketInteractionBuilder.prototype.withChannel = function (channel) {
        this.ticketInteraction.channel = channel;
        return this;
    };
    TicketInteractionBuilder.prototype.withStatus = function (status) {
        this.ticketInteraction.status = status;
        return this;
    };
    TicketInteractionBuilder.prototype.withLastAssignedGroupId = function (lastAssignedGroupId) {
        this.ticketInteraction.lastAssignedGroupId = lastAssignedGroupId;
        return this;
    };
    TicketInteractionBuilder.prototype.withLastAssignedUserId = function (lastAssignedUserId) {
        this.ticketInteraction.lastAssignedUserId = lastAssignedUserId;
        return this;
    };
    TicketInteractionBuilder.prototype.withParticipants = function (participants) {
        this.ticketInteraction.participants = participants;
        return this;
    };
    TicketInteractionBuilder.prototype.withTransferInfo = function (transferInfo) {
        this.ticketInteraction.transferInfo = transferInfo;
        return this;
    };
    TicketInteractionBuilder.prototype.withStartedByUser = function (startedByUser) {
        this.ticketInteraction.startedByUser = startedByUser;
        return this;
    };
    TicketInteractionBuilder.prototype.withEndedByUser = function (endedByUser) {
        this.ticketInteraction.endedByUser = endedByUser;
        return this;
    };
    TicketInteractionBuilder.prototype.withFirstResponseDate = function (firstResponseDate) {
        this.ticketInteraction.firstResponseDate = firstResponseDate;
        return this;
    };
    TicketInteractionBuilder.prototype.withFirstHumanResponseDate = function (firstHumanResponseDate) {
        this.ticketInteraction.firstHumanResponseDate = firstHumanResponseDate;
        return this;
    };
    TicketInteractionBuilder.prototype.withWaitingStartDate = function (waitingStartDate) {
        this.ticketInteraction.waitingStartDate = waitingStartDate;
        return this;
    };
    TicketInteractionBuilder.prototype.withWaitingEndDate = function (waitingEndDate) {
        this.ticketInteraction.waitingEndDate = waitingEndDate;
        return this;
    };
    TicketInteractionBuilder.prototype.withActiveStartDate = function (activeStartDate) {
        this.ticketInteraction.activeStartDate = activeStartDate;
        return this;
    };
    TicketInteractionBuilder.prototype.withActiveEndDate = function (activeEndDate) {
        this.ticketInteraction.activeEndDate = activeEndDate;
        return this;
    };
    TicketInteractionBuilder.prototype.withEndDate = function (endDate) {
        this.ticketInteraction.endDate = endDate;
        return this;
    };
    TicketInteractionBuilder.prototype.withFirstAssignmentDate = function (firstAssignmentDate) {
        this.ticketInteraction.firstAssignmentDate = firstAssignmentDate;
        return this;
    };
    TicketInteractionBuilder.prototype.withCreationDate = function (creationDate) {
        this.ticketInteraction.creationDate = creationDate;
        return this;
    };
    TicketInteractionBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.ticketInteraction.lastUpdateDate = lastUpdateDate;
        return this;
    };
    TicketInteractionBuilder.prototype.build = function () {
        return this.ticketInteraction;
    };
    return TicketInteractionBuilder;
}());
export { TicketInteractionBuilder };
//# sourceMappingURL=ticket-interaction.builder.js.map